import { useEffect, useState } from "react";
import { classHeartRateUrl } from "../client-api/fits";
import { ClassHrBoardSnapshot } from "../types";

/**
 * 그룹 수업 실시간 심박 보드(SSE). 서버가 1초마다 board 이벤트로 전체 스냅샷을 보낸다.
 * 연결이 끊기면 EventSource 가 알아서 다시 붙는다.
 */
function useClassHeartRate(classId: number | undefined, enabled: boolean) {
  const [board, setBoard] = useState<ClassHrBoardSnapshot>();

  useEffect(() => {
    const username = localStorage.getItem("username");
    if (!enabled || classId === undefined || !username) return;

    const source = new EventSource(classHeartRateUrl(classId, username));
    const handleBoard = (event: MessageEvent) => {
      try {
        setBoard(JSON.parse(event.data));
      } catch (e) {
        console.log(e);
      }
    };
    source.addEventListener("board", handleBoard);

    return () => {
      source.removeEventListener("board", handleBoard);
      source.close();
    };
  }, [classId, enabled]);

  return board;
}

export default useClassHeartRate;
